import yup from '../../../../helpers/yupInstance';
import type { TFunction } from 'i18next';

export function getAddBugReportTypesFormValidation(t: TFunction) {
  return yup.object({
    nameKey: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .required(t('formikValidation.nameKeyRequired')),
    priority: yup
      .number()
      .min(1, t('formikValidation.minValue').replace('{0}', '1'))
      .required(t('formikValidation.priorityRequired')),
  });
}
